// The Vue build version to load with the `import` command
import Vue from "vue";
// import 'babel-polyfill';
import App from "../src/containers/App.vue";
import axios from "axios";
import ElementUI from "element-ui";
// import store from './store'
import "element-ui/lib/theme-chalk/index.css";
import "es6-promise/auto";
import style_reset from "../src/assets/style/reset.css";
import style_app from "../src/assets/style/app.css";
import style_animation from "../src/assets/style/animation.css";
import style_font from "../src/assets/style/iconfont.css";
// 引入路由
import router from "./router.js";

Vue.use(ElementUI);

Vue.config.productionTip = false;

//在main.js设置全局的请求次数，请求的间隙
// 设置axios默认参数
axios.defaults.timeout = 4000;
axios.defaults.retry = 2;
axios.defaults.retryDelay = 500;
axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
	var config = err.config;
	// If config does not exist or the retry option is not set, reject
	if (!config || !config.retry) return Promise.reject(err);
	// Set the variable for keeping track of the retry count
	config.__retryCount = config.__retryCount || 0;
	// Check if we've maxed out the total number of retries
	if (config.__retryCount >= config.retry) {
		// Reject with the error
		return Promise.reject(err);
	}
	// Increase the retry count
	config.__retryCount += 1;
	// Create new promise to handle exponential backoff
	var backoff = new Promise(function(resolve) {
		setTimeout(function() {
			resolve();
		}, config.retryDelay || 1);
	});
	// Return the promise in which recalls axios to retry the request
	return backoff.then(function() {
		return axios(config);
	});
});

Vue.prototype.$http = axios;

// 百度统计
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function() {
	var hm = document.createElement("script");
	hm.src = "https://hm.baidu.com/hm.js?559dcd20841c73d175b6181597428eb7";
	var s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(hm, s);
})();

/* eslint-disable no-new */
new Vue({
	el: "#app_container",
	//   store,
	router,
	components: { App },
	template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js